module.exports = __webpack_public_path__ + "img/nav_logo.eae41a90.png";